import { tryJsonParse, getValueByPath, setValueByPath } from "../../utils";

export const setLocalStorageValue = (path: string[], value: any) => {
	let storageObject = tryJsonParse(localStorage.getItem("POW") || "", {});
	storageObject = setValueByPath(path, value, storageObject);
	localStorage.setItem("POW", JSON.stringify(storageObject));
};

export const getLocalStorageValue = (path: string[]) => {
	const storageObject = tryJsonParse(localStorage.getItem("POW") || "", {});
	return getValueByPath(path, storageObject);
};
